import {
  ModalType,
  useModalContext,
  useFeatureFlagContext,
} from 'modules/campaigns/editor/context';
import { useSendTimeExperiment } from 'modules/campaigns/editor/hooks';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { Send24 } from 'ui/icons';
import { CampaignPopover } from '../../../CampaignPopover';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const SendCampaignNowAction = () => {
  const { openModal } = useModalContext();
  const { isSuspendSendsEnabled } = useFeatureFlagContext();
  const { hasSendTimeExperiment } = useSendTimeExperiment();
  const buttonText = hasSendTimeExperiment ? 'Start Send Time Experiment' : 'Send now';
  return (
    <CampaignPermissionCheck action="send" ChildWrapper={CampaignPopover}>
      <SecondaryButton
        data-test="send-now-button"
        size={BUTTON_SIZES.LARGE}
        isDisabled={isSuspendSendsEnabled}
        onClick={() =>
          openModal(
            hasSendTimeExperiment
              ? ModalType.SendTimeExperimentCampaignModal
              : ModalType.SendCampaign,
          )
        }
      >
        <Send24 />
        {buttonText}
      </SecondaryButton>
    </CampaignPermissionCheck>
  );
};
